// C.1 — нейтральные Действия (Action-карты).
//
// Карты:
//   - «Прайс-лист» (neutral_act_price_list) — Order: draw 2.

import { registerImplementedAbility } from '../warn-unimplemented.js';
import { applyDrawEffect } from '../../effects/helpers.js';

export const PRICE_LIST_ID = 'neutral_act_price_list';

// Список cardId, для которых нужна цель при розыгрыше Действия.
const TARGETED_ACTIONS = new Set([
  // Прайс-лист не нуждается в выборе цели.
]);

export function actionNeedsTarget(cardId) {
  return TARGETED_ACTIONS.has(cardId);
}

export function getActionTargets(/* state, playerIdx, cardId */) {
  return [];
}

// Резолвер Действия. playerIdx — кто играет, cardId — id Действия.
export function resolveAction(state, playerIdx, cardId /* , opts */) {
  if (cardId !== PRICE_LIST_ID) return { ok: false, reason: 'unknown_action' };

  const p = state.players?.[playerIdx];
  if (!p) return { ok: false, reason: 'no_player' };

  // applyDrawEffect ожидает source с ownerId — передаём «псевдокарту».
  const drawn = applyDrawEffect(state, { ownerId: playerIdx }, 2);
  state.log?.add(`📋 «Прайс-лист» [${p.name}]: добрано ${drawn} карт`);
  return { ok: true, drawn };
}

registerImplementedAbility(PRICE_LIST_ID, 'order');
